const galleryItems = document.querySelectorAll('.gallery__item');
const galleryPopups = document.querySelectorAll('.gallery__item-popup');
const galleryPopupsClose = document.querySelectorAll('.gallery__item-popup-close');
const galleryOverlay = document.querySelector('.gallery__overlay'); 
const gallerySection = document.querySelector('.gallery');

galleryItems.forEach((item, index) => {
  item.addEventListener('click', function(e) {
    galleryPopups[index].classList.add('active');
    galleryOverlay.classList.add('active'); 
    gallerySection.classList.add('popup-visible'); 
    document.body.classList.add('body-locked');  
  });
});

galleryPopupsClose.forEach((button, index) => {
  button.addEventListener('click', function(e) {
    galleryPopups[index].classList.remove('active');
    galleryOverlay.classList.remove('active');
    gallerySection.classList.remove('popup-visible');  
    document.body.classList.remove('body-locked');  
  });
});

galleryOverlay.addEventListener('click', function() {
  document.querySelectorAll('.gallery__item-popup.active').forEach((popup) => {
    popup.classList.remove('active'); 
  });
  galleryOverlay.classList.remove('active');
  gallerySection.classList.remove('popup-visible');
  document.body.classList.remove('body-locked');
});